// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"ChartCard_pattern-gradient__jGq3A","box":"ChartCard_box__61-Mp"};